// src/components/PartnerPrivateRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../pages/login/AuthProvider";

function PartnerPrivateRoute({ children }) {
  const { authorized, type } = useAuth();
  const location = useLocation();

  // 沒登入，或登入的人不是 partner，就踢回登入頁
  if (!authorized || type !== "partner") {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/adm/admlogin?redirect=${redirect}`} replace />;
  }

  return children;
}

export default PartnerPrivateRoute;
